import { usePageTitle } from "@/hooks/usePageTitle";

import { ApiReferenceRedirect } from "./ApiReferenceRedirect";

/** Redirects to Redoc HTML (`npm run build:glofox-api-docs` → public/). */
export default function ApiReferencePage() {
  usePageTitle("API Reference — Glofox");
  return <ApiReferenceRedirect />;
}
